import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Services", href: "#services" },
  { label: "Why Betty", href: "#manifesto" },
  { label: "Gallery", href: "#gallery" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ offset = false }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    if (window.lenis) {
      window.lenis.scrollTo(href, { offset: -80 });
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      data-testid="navbar"
      className={`fixed ${offset ? "top-10" : "top-0"} inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color,padding,top] duration-500 ${
        scrolled
          ? "bg-[#EFD9AE]/80 backdrop-blur-xl border-b border-[#C68A3A]/50 py-3"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          onClick={() => go("#top")}
          data-testid="nav-logo"
          className="group text-left"
        >
          <span className="flex flex-col leading-none">
            <span className="font-serif text-2xl text-[#241B2E] group-hover:text-[#C1440E] transition-colors duration-300">
              Betty Bell's
            </span>
            <span className="text-[0.6rem] tracking-[0.3em] uppercase text-[#5A2E14] mt-1.5">
              Cleaning Services LLC
            </span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="relative text-sm text-[#5A2E14] hover:text-[#241B2E] transition-colors duration-300 after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-[#C1440E] after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => go("#contact")}
          data-testid="nav-cta"
          className="text-sm px-5 py-2.5 rounded-full bg-[#241B2E] text-[#EFD9AE] hover:bg-[#C1440E] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
        >
          Get a Quote
        </button>
      </div>
    </motion.nav>
  );
}
